import IconButton from '@mui/material/IconButton';
import { closeSnackbar, SnackbarProvider as NotistackProvider } from 'notistack';
import { useRef } from 'react';

import { MdCheck, MdClose, MdError, MdInfo, MdWarning } from 'react-icons/md';
import OrderProgressSnackbar from './order-progress';
import OrderSnackbar from './order-snackbar';
import { StyledIcon, StyledNotistack } from './styles';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function SnackbarProvider({ children }: Props) {
  const notistackRef = useRef(null);

  return (
    <NotistackProvider
      ref={notistackRef}
      maxSnack={5}
      preventDuplicate
      autoHideDuration={3000}
      variant="success" // Set default variant
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      iconVariant={{
        info: (
          <StyledIcon color="info">
            <MdInfo size={24} />
          </StyledIcon>
        ),
        success: (
          <StyledIcon color="success">
            <MdCheck size={24} />
          </StyledIcon>
        ),
        warning: (
          <StyledIcon color="warning">
            <MdWarning size={24} />
          </StyledIcon>
        ),
        error: (
          <StyledIcon color="error">
            <MdError />
          </StyledIcon>
        )
      }}
      Components={{
        default: StyledNotistack,
        info: StyledNotistack,
        success: StyledNotistack,
        warning: StyledNotistack,
        error: StyledNotistack,
        order: OrderSnackbar,
        orderProgress: OrderProgressSnackbar
      }}
      // with close as default
      action={(snackbarId) => (
        <IconButton size="small" onClick={() => closeSnackbar(snackbarId)} sx={{ p: 0.5 }}>
          <MdClose />
        </IconButton>
      )}
    >
      {children}
    </NotistackProvider>
  );
}
